import { FC } from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import { useBlocksContext } from '../lib/blocks.context';

const Paragraph: FC<TextProps> = ({ size, ...rest }) => {
  const { hero } = useBlocksContext();
  const isHero = hero?.isHero ?? false;

  const finalSize = isHero ? 'xl' : size || 'lg';
  return (
    <Text
      textStyle={finalSize}
      sx={{ ':not(:last-child)': { mb: 5 } }}
      {...rest}
    />
  );
};

export default Paragraph;
